import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Container, Divider, Typography, Button } from '@mui/material';
import classes from './ErrorPage.module.css';
import errorImage from '../../../assets/img/404.svg';
import MetaTags from '../../MetaTags/MetaTags';
import Header from '../../Header.jsx/Header';
import Footer from '../../Footer/Footer';
import Wrapper from '../../UI/Wrapper';

const ErrorPage = () => {
    const navigate = useNavigate();

    const goToHome = () => {
        navigate('/');
    };

    return (
        <>
            <Header />
            <Wrapper>
                <Container sx={{ padding: '100px 0' }}>
                    <MetaTags
                        title="페이지 404 오류"
                        description="해당 페이지를 찾을 수 없습니다."
                        ogtitle="드림산업안전센터(주)-페이지 오류"
                        ogdescription="해당 페이지를 찾을 수 없습니다."
                    />
                    <Box>
                        <Box display={'flex'} justifyContent={'center'} alignItems={'center'}>
                            <img className={classes.image} src={errorImage} alt="404error" />
                        </Box>

                        <Divider sx={{ margin: '50px 0' }} />

                        <Typography variant="h4" component="h1" textAlign={'center'}>
                            요청하신 페이지가 존재하지 않습니다.
                        </Typography>

                        <Divider sx={{ margin: '50px 0' }} />

                        <Box textAlign={'center'}>
                            <Button variant="outlined" onClick={goToHome}>
                                홈으로 이동
                            </Button>
                        </Box>
                    </Box>
                </Container>
            </Wrapper>
            <Footer />
        </>
    );
};

export default ErrorPage;
